import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-df77f142"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "column is-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Descrição", -1))
const _hoisted_3 = { class: "column is-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Projeto", -1))
const _hoisted_5 = { class: "column" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Tempo Gasto", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Cronometro = _resolveComponent("Cronometro")!
  const _component_Box = _resolveComponent("Box")!

  return (_openBlock(), _createBlock(_component_Box, null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "columns cursor",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.tarefaClicked && _ctx.tarefaClicked(...args)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createTextVNode(" " + _toDisplayString(_ctx.tarefa.description || "Tarefa sem Descrição"), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.tarefa.projeto?.name || "N/D"), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_Cronometro, {
            timeInSeconds: _ctx.tarefa.timeInSeconds
          }, null, 8, ["timeInSeconds"])
        ])
      ])
    ]),
    _: 1
  }))
}